import { connect } from 'react-redux';
import React, { Component } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const centerText = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}

class excelTestSolutionUpload extends Component {
	constructor(props) {
		super(props)
		this.state = {
			file: null,
		}
		this.onChangeFile = this.onChangeFile.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onDownload = this.onDownload.bind(this);
	}

	onDownload(e) {
		e.preventDefault();
		const link = document.createElement('a');
		link.href = `lgtest.7z`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		axios.post(`/api/excelApi/excelDownloaded/`)
			.then(resp => {
				Swal.fire(
					'Fajl je preuzet',
					resp.data.message,
					resp.data.sign
				)
			})
			.catch(err => {
			})
	}

	onChangeFile(e) {
		this.setState({ file: e.target.files }, () => { console.log(this.state.file) });
	}

	handleFileUpload = event => {
		console.log(event.target.files.name);
	};

	async onSubmit(e) {
		e.preventDefault();
		const formData = new FormData()
		for (let i = 0; i < this.state.file.length; i++) {
			const fileNo = `file-${0}`
			const fileValue = this.state.file[i]
			const fileName = this.state.file[i].name
			formData.set(
				fileNo,
				fileValue,
				fileName
			);
			await axios.post(`/api/excelApi/uploadResult/`, formData)
				.then(resp => {
					console.log(resp)
					Swal.fire(
						'Rezultati su uspešno poslati! ',
						resp.data.message,
						resp.data.sign
					)
					this.props.history.push('/welcomePage')
				})
				.catch(err => {
					console.log(err)
					//neki swal da opalim ovde
				})

		}
	}

	render() {
		return (
			<div className="Content">
				<div style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "inherit",
					padding: "3px"
				}}>
					<div style={{
						width: "80%",
						height: "80%",
						background: "#fff",
						boxShadow: "15px 15px 25px #ccc",
						borderRadius: "15px"
					}}>
						<div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
							<div style={{ padding: "16px 0", textAlign: "left" }}>
								<br /><br />
								Zdravo {this.props.auth.user.name},
								<br /><br />
								Pred tobom se nalazi test poznavanje Excela. Klikom na dugme "Preuzmi test" preuzimate zipovan fajl u okviru kog se nalazi excel fajl u kom radite zadatke i Word fajl za opisima zadataka.
								<br /><br />
								Za ovaj test imate 1 sat i 40 minuta koji kreću od momenta kada pritisnete dugme "Preuzmi test".
								<br />
								Kada završiš test možeš ga poslati klikom na dugme "Predaj test", potrebno je da priložite urađen Excel.
								<br /><br />
								Srećno
								<br /><br />
								<div style={centerText}>
									<button className="btn btn-info btn-fill col-md-3" value="Preuzmi test" onClick={this.onDownload}>Preuzmi test</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br /><br />
				<div style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "inherit",
					padding: "3px"
				}}>
					<div style={{
						width: "80%",
						height: "80%",
						background: "#fff",
						boxShadow: "15px 15px 25px #ccc",
						borderRadius: "15px"
					}}>
						<br />
						<div style={centerText}>
							Pošalji rešenje excel testa
						</div>
						<br />
						<div style={centerText}>
							<div className="row">
								<form onSubmit={this.onSubmit} className='justify-content-center'>
									<input type="file" onChange={this.onChangeFile} name="file" multiple />
									<button className="btn btn-info btn-fill" type="submit" >Unesi</button>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	auth: state.auth,
});

export default connect(
	mapStateToProps,
)(excelTestSolutionUpload);